import './NotFound.css'
import React from 'react';

const NotFound = () => {
    return (
        <div className='notfound'>
            
        </div>
    );
};

export default NotFound;